import { useBindProp as o } from "../props.js";
import t from "./visible.js";
import r from "./z-index.js";
import s from "./opacity.js";
import m from "./zooms.js";

function i(i, e) {
  t(i, e), r(i, e), s(i, e), m(i, e), o(i, {
    setter: "setStyles"
  }, e.styles);
}

export default i;